import { Fragment, useState } from 'react';
import { NextPage } from 'next';

import { field, useForm, useSubmit, validate } from '@reckon-web/forms';
import { Flex } from '@reckon-web/flex';
import { Button } from '@reckon-web/button';
import { Box } from '@reckon-web/box';
import { Radio } from '@reckon-web/radio';
import { Stack } from '@reckon-web/stack';
import { Heading } from '@reckon-web/heading';

import { TextField } from '../generic/TextField';

export const RevokeSMSMFAForm: NextPage<{
  sendCode?: any;
  revokeSMFAWithCode?: any;
  revokeSMFAWithPin?: any;
  setErrorMessage?: any;
}> = ({ sendCode, revokeSMFAWithCode, revokeSMFAWithPin, setErrorMessage }) => {
  let [means, setMeans] = useState<string>('code');
  let revokeSMSMFAForm = field.object({
    pin: field.text({
      validate: validate((value) => {
        if (means === 'pin' && !value.length)
          return validate.error('Enter the pin');
        return value;
      }),
    }),
    code: field.text({
      validate: validate((value) => {
        if (means === 'code' && !value.length)
          return validate.error('Enter the code');
        return value;
      }),
    }),
  });

  let form = useForm(revokeSMSMFAForm);
  const selectMeans = (e: any) => {
    setMeans(e.target.value);
  };
  const submit = useSubmit(form, async (value) => {
    if ((means === 'pin' && !value.pin) || (means === 'code' && !value.code))
      return;
    try {
      if (means === 'pin') revokeSMFAWithPin(value.pin);
      else if (means === 'code') revokeSMFAWithCode(value.code);
    } catch (err: any) {
      setErrorMessage(err.message);
    }
  });
  return (
    <Fragment>
      <form
        id="revoke-smfa-form"
        onChange={() => setErrorMessage('')}
        onSubmit={submit}
      >
        <Flex
          direction="column"
          gap="medium"
          alignItems="center"
          padding="xlarge"
          marginTop="medium"
        >
          <Heading level="3">
            Revoke Multi-Factor Authentication Using...
          </Heading>
          <Box
            paddingX="large"
            paddingY="medium"
            borderRadius="small"
            width={400}
          >
            <Stack gap="medium">
              <Radio
                name="demo-radios"
                value={'code'}
                checked={means === 'code'}
                onChange={selectMeans}
              >
                MFA code
              </Radio>
              <Radio
                name="demo-radios"
                value={'pin'}
                checked={means === 'pin'}
                onChange={selectMeans}
              >
                Recovery PIN
              </Radio>
            </Stack>
          </Box>
          <Box
            paddingX="medium"
            paddingY="medium"
            borderRadius="small"
            width={400}
          >
            {means === 'pin' ? (
              <TextField
                type="text"
                label="RecoveryPIN"
                labelVisible={false}
                placeholder="Enter your Recovery PIN"
                {...form.fields.pin.props}
              />
            ) : (
              <Box marginTop="small">
                <Button
                  id="send-code"
                  size="medium"
                  block
                  label="Send Code"
                  onClick={() => sendCode()}
                />
                <TextField
                  type="text"
                  label="Enter MFA code"
                  {...form.fields.code.props}
                />
              </Box>
            )}
          </Box>
          <Box
            paddingX="medium"
            paddingY="medium"
            borderRadius="small"
            width={400}
          >
            <Box marginTop="medium">
              <Button
                id="login"
                disabled={form.validity !== 'valid'}
                type="submit"
                size="medium"
                block
                label="Submit"
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </Fragment>
  );
};
